import logoImage from "../../assest/images/logo-img.png"
import whiteLogoImage from "../../assest/images/whitelogo.png";
import backgroundImg from "../../assest/images/securitybg2.png"
import { Link } from "react-router-dom"
import LastBox from "../../components/LastBox"

const Index = ({ verify, state, changeValue, handlePaste, handlePasteButtonClick, canResend, timer, resendOtp, formatTime, userlang }) => {
    const { otp, error } = state;

    return (
        <section className="loginSec" style={{ backgroundImage: `url(${backgroundImg})` }}>
            <div className="loginpart">
                <div className="container">
                    <div className="loginBox optSection">
                        <div className="logoSec">
                            {/* <Link to={'/'}><img src={logoImage} alt="logo-img" /></Link> */}
                            <Link to={'/' + userlang} className='comLogo'>
                                <img src={logoImage} alt="logo-img" />
                            </Link>
                            <Link to={'/' + userlang} className='whitelogo'><img src={whiteLogoImage} alt="logo-img" /></Link>
                            <h4>Security Verification <br /> Requirements</h4>
                            <h6>We have sent the verification code to your email</h6>
                        </div>
                        <form onSubmit={verify}>
                            <div className="getOtpBox">
                                <input
                                    type="text"
                                    className="commonInput"
                                    id="otp"
                                    name="otp"
                                    value={otp}
                                    onChange={changeValue}
                                    onPaste={handlePaste}
                                    maxLength="6"
                                />
                                <a className="comYellowa" href="javascript:void(0)" onClick={(e) => handlePasteButtonClick(e)}>PASTE</a>

                                {error && error.otp && <span className="cus-err" style={{ top: "100%" }}>{error.otp}</span>}
                            </div>
                            <div className="register">
                                <p>You did not receive the code
                                    {/* <a className="comYellowa" href="javascript:void(0)" >Resend</a> */}
                                    {canResend ? (
                                        <a className="comYellowa" href="javascript:void(0)" onClick={() => resendOtp()}>Resend</a>
                                    ) : (
                                        <span className="disabled">&nbsp;Resend in {formatTime(timer)}</span>
                                    )}
                                </p>
                            </div>
                        </form>
                    </div>
                    <LastBox userlang={userlang} />
                </div>
            </div>
        </section>
    )

}
export default Index;